import React from "react";

import {
  REFERRAL_BODY_LINES,
  REFERRAL_EYEBROW,
  REFERRAL_FOOTNOTE,
  REFERRAL_HEADING_LINES,
} from "components/Screens/LoginV2/ReferralOverlay/constants";

import "./ReferralOverlay.scss";

// The design breaks the headline and the body at fixed points, so the lines are
// joined with <br /> rather than left to wrap. Each line is a text node of the
// styled element on purpose: a wrapper element would be matched by the global
// `*` font-family rule in index.css and fall back to Poppins.
const renderLines = (lines: string[]) =>
  lines.map((line, index) => (
    <React.Fragment key={line}>
      {index > 0 && <br />}
      {line}
    </React.Fragment>
  ));

function ReferralOverlay() {
  return (
    <div className="referral-overlay" data-testid="referral-overlay">
      <div className="referral-intro">
        <div className="para-body-s-regular referral-eyebrow">{REFERRAL_EYEBROW}</div>

        <div className="display-h3-semibold referral-heading">{renderLines(REFERRAL_HEADING_LINES)}</div>
      </div>

      <div className="para-body-l-regular referral-body">{renderLines(REFERRAL_BODY_LINES)}</div>

      <div className="para-body-s-regular referral-footnote">{REFERRAL_FOOTNOTE}</div>
    </div>
  );
}

export default ReferralOverlay;
